import { gql } from '@apollo/client/core';
import Money from '../../../gqlCommon/graphql/fragments/money';

const simpleSpecPackPrices = {
  SIMPLE_SPEC_PACK_PRICES: gql`
    ${Money.MONEY}
    fragment SimpleSpecPackPrices on Prices {
      carPrice {
        ...CarPrice
      }
      totalPrice {
        money {
          ...Money
        }
        type
      }
    }
  `,
};

export default simpleSpecPackPrices;
